var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};

// elements/components/x-empty-placeholder.ts
import { AdornisRouter } from "@adornis/base/client/a-router";
import { html, nothing } from "lit";
import { customElement, property, state } from "lit/decorators.js";
import { ChemistryLitElement } from "../../chemistry-lit-element";
import { css } from "../../directives/css";
import { DesignSystem } from "../theming/design";
import { xComponents } from "../x-components";
import "./x-card";
import "./x-link";
var ElementsEmptyPlaceholder = class extends ChemistryLitElement {
  constructor() {
    super(...arguments);
    this.styles = () => ({
      ":host": { textAlign: "center" },
      [`${DesignSystem.prefix}-icon`]: { fontSize: "84px", color: this.colors.neutral_200 }
    });
    this["no-wrapper"] = false;
    this.text = "";
    this.img = "";
    this["back-text"] = "";
  }
  render() {
    if (this["no-wrapper"])
      return xComponents(this.message());
    return xComponents(html`
      <x-flex center crossaxis-center ${css({ height: "100%", width: "100%" })}>
        <x-card ${css({ width: "min(90vw, 350px)" })}> ${this.message()} </x-card>
      </x-flex>
    `);
  }
  message() {
    return html`
      <x-flex
        space="lg"
        padding="xl"
        crossaxis-center
        center
        ${css(this["no-wrapper"] ? { height: "100%", width: "100%" } : {})}
      >
        ${this.icon()} ${this.textPart()} ${this.backButton()}
      </x-flex>
    `;
  }
  icon() {
    return typeof this.img === "string" ? html` <x-icon> ${this.img} </x-icon> ` : this.img;
  }
  textPart() {
    return this.text ? typeof this.text === "string" ? html` <x-text> ${this.text} </x-text> ` : this.text : nothing;
  }
  backButton() {
    return this["back-text"] ? html`
          <x-text>
            <x-link
              @click="${() => {
      try {
        window.history.back();
      } catch {
        AdornisRouter.goTo("/");
      }
    }}"
            >
              ${this["back-text"]}
            </x-link>
          </x-text>
        ` : nothing;
  }
};
__decorateClass([
  property({ type: Boolean })
], ElementsEmptyPlaceholder.prototype, "no-wrapper", 2);
__decorateClass([
  state()
], ElementsEmptyPlaceholder.prototype, "text", 2);
__decorateClass([
  state()
], ElementsEmptyPlaceholder.prototype, "img", 2);
__decorateClass([
  property()
], ElementsEmptyPlaceholder.prototype, "back-text", 2);
ElementsEmptyPlaceholder = __decorateClass([
  customElement("x-empty-placeholder")
], ElementsEmptyPlaceholder);
export {
  ElementsEmptyPlaceholder
};
